import { render, staticRenderFns } from "./history-tab.vue?vue&type=template&id=b832649a&scoped=true"
import script from "./history-tab.vue?vue&type=script&lang=js"
export * from "./history-tab.vue?vue&type=script&lang=js"
import style0 from "./history-tab.vue?vue&type=style&index=0&id=b832649a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b832649a",
  null
  
)

export default component.exports